import { Fragment } from "react";
import ListadoArticulos from "./ListadoArticulos";

const ArticulosEquivalentes = (props) => {
  switch (props.origen) {
    case "tabla":
      return (
        <Fragment>
          <ListadoArticulos mostrar="tabla" origen="equivalentes" id_articulo={props.id_articulo} set_hay_equivalentes={props.existen_relacionados} />
        </Fragment>
      );
    case "ficha":
      return (
        <Fragment>
          <ListadoArticulos mostrar="lista" origen="equivalentes" id_articulo={props.id_articulo} set_hay_equivalentes={props.existen_relacionados} />
        </Fragment>
      );

    default:
      return "";
  }
};

export default ArticulosEquivalentes;
